module.exports = __webpack_public_path__ + "static/img/1036_big.f56b755.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1036_big.png
// module id = rEmD
// module chunks = 1